/* eslint-disable */

/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType
} from 'axios';
import axios from 'axios';

export interface DomainsCategoryPreference {
  category?: string;
  events?: DomainsEvent[];
}

export interface DomainsChannelDetails {
  name?: string;
  value?: boolean;
}

export interface DomainsCheckSubscription {
  subscribed?: boolean;
}

export interface DomainsEvent {
  channels?: DomainsChannelDetails[];
  description?: string;
  name?: string;
}

export interface DomainsFeedItem {
  action_url?: string;
  event?: string;
  message_id?: string;
  message_text?: string;
  org_id?: string;
  status?: string;
  timestamp?: string;
}

export interface DomainsFeedItems {
  messages?: DomainsFeedItem[];
}

export interface DomainsFeedUnreadCount {
  count?: number;
}

export interface DomainsFrontierEvent {
  action?: string;
  data?: {
    metadata?: Record<string, string>;
    org_id?: string;
    target?: {
      id?: string;
      type?: string;
    };
  };
  id?: string;
}

export interface DomainsImplicitSubscriptionSetRequest {
  related_subscription?: DomainsRelatedSubscription;
  resource_id?: string;
  resource_type?: string;
}

export interface DomainsListSubscriptionResponse {
  pagination?: DomainsPagination;
  subscriptions?: DomainsListSubscriptionResponseItem[];
}

export interface DomainsListSubscriptionResponseItem {
  org_id?: string;
  project_id?: string;
  project_name?: string;
  resource_creator?: string;
  resource_id?: string;
  resource_name?: string;
  resource_type?: string;
}

export interface DomainsPagination {
  limit?: number;
  offset?: number;
  total_count?: number;
}

export interface DomainsRelatedSubscription {
  resource_id?: string;
  resource_type?: string;
}

export interface DomainsSendNotificationRequest {
  actor?: string;
  data?: Record<string, any>;
  event?: string;
  resource_id?: string;
  resource_type?: string;
}

export interface DomainsUser {
  email?: string;
  id?: string;
  name?: string;
}

export interface DomainsUserPreferences {
  org_id?: string;
  preferences?: DomainsCategoryPreference[];
  user_id?: string;
}

export interface DomainsUserPreferencesSetRequest {
  preferences?: DomainsCategoryPreference[];
}

export interface ErrorsApiError {
  error?: ErrorsError;
}

export interface ErrorsError {
  code?: string;
  details?: Record<string, string>;
  message?: string;
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || ''
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {})
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    });
  };
}

/**
 * @title Beacon Service API Doc
 * @version 0.1
 * @contact Abhishek Sah <abhisheksah@pixxel.co.in>
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  ping = {
    /**
     * No description
     *
     * @tags external
     * @name PingList
     * @summary Ping Server
     * @request GET:/ping
     */
    pingList: (params: RequestParams = {}) =>
      this.request<Record<string, string>, any>({
        path: `/ping`,
        method: 'GET',
        format: 'json',
        ...params
      })
  };
  v1 = {
    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfFeedList
     * @summary Get In-app feed for a user
     * @request GET:/v1/api/user/self/feed
     */
    apiUserSelfFeedList: (params: RequestParams = {}) =>
      this.request<DomainsFeedItems, ErrorsApiError>({
        path: `/v1/api/user/self/feed`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfFeedUnreadCountList
     * @summary Get count of unread messages in In-app feed for a user
     * @request GET:/v1/api/user/self/feed/unread_count
     */
    apiUserSelfFeedUnreadCountList: (params: RequestParams = {}) =>
      this.request<DomainsFeedUnreadCount, ErrorsApiError>({
        path: `/v1/api/user/self/feed/unread_count`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfPreferencesList
     * @summary Get notification preferences for a user
     * @request GET:/v1/api/user/self/preferences
     */
    apiUserSelfPreferencesList: (params: RequestParams = {}) =>
      this.request<DomainsUserPreferences, ErrorsApiError>({
        path: `/v1/api/user/self/preferences`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfPreferencesUpdate
     * @summary Set notification preferences for a user
     * @request PUT:/v1/api/user/self/preferences
     */
    apiUserSelfPreferencesUpdate: (
      req: DomainsUserPreferencesSetRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/api/user/self/preferences`,
        method: 'PUT',
        body: req,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name MarkAllMessagesAsRead
     * @summary Mark all in-app messages as read
     * @request POST:/v1/api/user/self/read
     */
    markAllMessagesAsRead: (params: RequestParams = {}) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/api/user/self/read`,
        method: 'POST',
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name MarkAMessageAsRead
     * @summary Mark an in-app message read
     * @request POST:/v1/api/user/self/read/{message_id}
     */
    markAMessageAsRead: (messageId: string, params: RequestParams = {}) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/api/user/self/read/${messageId}`,
        method: 'POST',
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ListSubscriptions
     * @summary List all resources where the user is subscribed
     * @request GET:/v1/api/user/self/subscription
     */
    listSubscriptions: (
      query: {
        /** offset */
        offset: number;
        /** limit */
        limit: number;
        /** resource_type */
        resource_type?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DomainsListSubscriptionResponse, ErrorsApiError>({
        path: `/v1/api/user/self/subscription`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfSubscriptionDetail
     * @summary Check if a user is subscribed to a resource
     * @request GET:/v1/api/user/self/subscription/{resource_type}/{resource_id}
     */
    apiUserSelfSubscriptionDetail: (
      resourceType: string,
      resourceId: string,
      params: RequestParams = {}
    ) =>
      this.request<DomainsCheckSubscription, ErrorsApiError>({
        path: `/v1/api/user/self/subscription/${resourceType}/${resourceId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfSubscriptionCreate
     * @summary Subscribe any user to a resource NOT created by him
     * @request POST:/v1/api/user/self/subscription/{resource_type}/{resource_id}
     */
    apiUserSelfSubscriptionCreate: (
      resourceType: string,
      resourceId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/api/user/self/subscription/${resourceType}/${resourceId}`,
        method: 'POST',
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags external
     * @name ApiUserSelfSubscriptionDelete
     * @summary Remove subscription of a user from a resource
     * @request DELETE:/v1/api/user/self/subscription/{resource_type}/{resource_id}
     */
    apiUserSelfSubscriptionDelete: (
      resourceType: string,
      resourceId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/api/user/self/subscription/${resourceType}/${resourceId}`,
        method: 'DELETE',
        ...params
      }),

    /**
     * No description
     *
     * @tags internal
     * @name InternalNotificationCreate
     * @summary Send notification to user
     * @request POST:/v1/internal/notification
     */
    internalNotificationCreate: (
      req: DomainsSendNotificationRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/internal/notification`,
        method: 'POST',
        body: req,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags internal
     * @name InternalResetSubscriptionsCreate
     * @summary Reset subscriptions of a user
     * @request POST:/v1/internal/reset_subscriptions
     */
    internalResetSubscriptionsCreate: (
      req: DomainsFrontierEvent,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/internal/reset_subscriptions`,
        method: 'POST',
        body: req,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags internal
     * @name InternalUserCreate
     * @summary Update a user - To be called by Frontier webhook
     * @request POST:/v1/internal/user
     */
    internalUserCreate: (
      req: DomainsFrontierEvent,
      query?: {
        /** set_default_pref */
        resource_type?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DomainsUser, ErrorsApiError>({
        path: `/v1/internal/user`,
        method: 'POST',
        query: query,
        body: req,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags internal
     * @name InternalUserSubscribeCreate
     * @summary Subscribe any user to a resource created by him
     * @request POST:/v1/internal/user/{user_id}/subscribe
     */
    internalUserSubscribeCreate: (
      userId: string,
      req: DomainsImplicitSubscriptionSetRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorsApiError>({
        path: `/v1/internal/user/${userId}/subscribe`,
        method: 'POST',
        body: req,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags internal
     * @name InternalUserJoinedOrgCreate
     * @summary Create a new user and set default preferences - To be called by Frontier webhook when user has joined an org
     * @request POST:/v1/internal/user_joined_org
     */
    internalUserJoinedOrgCreate: (
      req: DomainsFrontierEvent,
      params: RequestParams = {}
    ) =>
      this.request<DomainsUser, ErrorsApiError>({
        path: `/v1/internal/user_joined_org`,
        method: 'POST',
        body: req,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
}
